'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CurrencyCodeToSymbol;

var _templateObject = _taggedTemplateLiteral(['\n    position: static;\n    top: 0;\n    text-align: center;\n    background-color: #f5f8fa;\n    .private-button__group.private-button__group--vertical > :first-child {\n      border-top-right-radius: 0;\n      border-bottom-right-radius: 0;\n      border-bottom-left-radius: 3px;\n    }\n    .private-button__group.private-button__group--vertical > :last-child {\n      border-top-left-radius: 0;\n      border-bottom-left-radius: 0;\n      border-top-right-radius: 3px;\n    }\n  '], ['\n    position: static;\n    top: 0;\n    text-align: center;\n    background-color: #f5f8fa;\n    .private-button__group.private-button__group--vertical > :first-child {\n      border-top-right-radius: 0;\n      border-bottom-right-radius: 0;\n      border-bottom-left-radius: 3px;\n    }\n    .private-button__group.private-button__group--vertical > :last-child {\n      border-top-left-radius: 0;\n      border-bottom-left-radius: 0;\n      border-top-right-radius: 3px;\n    }\n  ']),
    _templateObject2 = _taggedTemplateLiteral(['\n    padding: 0 15px;\n    .currency-symbol {\n      display: none;\n    }\n  '], ['\n    padding: 0 15px;\n    .currency-symbol {\n      display: none;\n    }\n  ']),
    _templateObject3 = _taggedTemplateLiteral(['\n      display: none;\n    '], ['\n      display: none;\n    ']),
    _templateObject4 = _taggedTemplateLiteral(['\n    position: static;\n    margin: 1.4em 0;\n    &.private-button__group.private-button__group--vertical {\n      flex-direction: row;\n    }\n  '], ['\n    position: static;\n    margin: 1.4em 0;\n    &.private-button__group.private-button__group--vertical {\n      flex-direction: row;\n    }\n  ']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _CurrencyCodes = require('self-service-api/constants/CurrencyCodes');

var CurrencyCodes = _interopRequireWildcard(_CurrencyCodes);

var _UIButtonGroup = require('UIComponents/button/UIButtonGroup');

var _UIButtonGroup2 = _interopRequireDefault(_UIButtonGroup);

var _UISelectableBox = require('UIComponents/button/UISelectableBox');

var _UISelectableBox2 = _interopRequireDefault(_UISelectableBox);

var _CurrencySelectors = require('pricing-pages-unified-ui/selectors/CurrencySelectors');

var _getUsageTracker = require('pricing-pages-unified-ui/utils/getUsageTracker');

var _getUsageTracker2 = _interopRequireDefault(_getUsageTracker);

var _ActiveCurrencyCodeActions = require('pricing-pages-unified-ui/actions/ActiveCurrencyCodeActions');

var _publicPageUrls = require('pricing-pages-unified-ui/utils/publicPageUrls');

var _responsiveBreakpoints = require('../../utils/responsiveBreakpoints');

var _responsiveBreakpoints2 = _interopRequireDefault(_responsiveBreakpoints);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CurrencyCodeToSymbol = (_CurrencyCodeToSymbol = {}, _defineProperty(_CurrencyCodeToSymbol, CurrencyCodes.USD, '$'), _defineProperty(_CurrencyCodeToSymbol, CurrencyCodes.EUR, '€'), _defineProperty(_CurrencyCodeToSymbol, CurrencyCodes.GBP, '£'), _defineProperty(_CurrencyCodeToSymbol, CurrencyCodes.AUD, '$'), _defineProperty(_CurrencyCodeToSymbol, CurrencyCodes.JPY, '¥'), _defineProperty(_CurrencyCodeToSymbol, CurrencyCodes.SGD, '$'), _defineProperty(_CurrencyCodeToSymbol, CurrencyCodes.COP, '$'), _CurrencyCodeToSymbol);

var CurrencySelectorWrapper = _styledComponents2.default.div.withConfig({
  displayName: 'CurrencyPicker__CurrencySelectorWrapper'
})(['position:-webkit-sticky;position:sticky;top:25%;z-index:2;', ';', ';.currency-symbol{', '}'], _responsiveBreakpoints2.default.tabletPortrait(_templateObject), _responsiveBreakpoints2.default.phone(_templateObject2), _responsiveBreakpoints2.default.phone(_templateObject3));

var StyledButtonGroup = (0, _styledComponents2.default)(_UIButtonGroup2.default).withConfig({
  displayName: 'CurrencyPicker__StyledButtonGroup'
})(['position:absolute;margin-top:100px;z-index:2;', ';'], _responsiveBreakpoints2.default.tabletPortrait(_templateObject4));

var StyledSelectableBox = (0, _styledComponents2.default)(_UISelectableBox2.default).withConfig({
  displayName: 'CurrencyPicker__StyledSelectableBox'
})(['z-index:5;:hover{z-index:6;}.currency-selector__text{font-size:12px;}', ''], function (_ref) {
  var selected = _ref.selected;
  return selected && (0, _styledComponents.css)(['z-index:6;']);
});

var CurrencyPicker = function CurrencyPicker(_ref2) {
  var availableCurrencies = _ref2.availableCurrencies,
      activeCurrencyCode = _ref2.activeCurrencyCode,
      onUpdateActiveCurrencyCode = _ref2.onUpdateActiveCurrencyCode;

  var handleClick = function handleClick(currency) {
    onUpdateActiveCurrencyCode(currency);
    (0, _getUsageTracker2.default)().track('selectCurrency', { currency: currency });
  };

  return availableCurrencies.length <= 1 ? null : _react2.default.createElement(
    CurrencySelectorWrapper,
    null,
    _react2.default.createElement(
      StyledButtonGroup,
      {
        orientation: 'vertical',
        className: 'currency-selector__button-group'
      },
      availableCurrencies.map(function (currency) {
        var selected = activeCurrencyCode === currency;
        var gaClassName = (0, _publicPageUrls.getGAClassName)('currency-pricing-' + currency.toLowerCase());
        return _react2.default.createElement(
          StyledSelectableBox,
          {
            key: currency,
            selected: selected,
            onClick: function onClick() {
              return handleClick(currency);
            },
            className: 'p-all-2 ' + gaClassName
          },
          _react2.default.createElement(
            'span',
            { className: 'currency-selector__text ' + gaClassName },
            currency,
            _react2.default.createElement(
              'span',
              { className: 'currency-symbol' },
              ' ',
              CurrencyCodeToSymbol[currency]
            )
          )
        );
      })
    )
  );
};

CurrencyPicker.propTypes = {
  availableCurrencies: _react.PropTypes.array.isRequired,
  activeCurrencyCode: _react.PropTypes.oneOf(Object.values(CurrencyCodes || {})),
  onUpdateActiveCurrencyCode: _react.PropTypes.func.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    availableCurrencies: (0, _CurrencySelectors.availableCurrenciesSelector)(state),
    activeCurrencyCode: (0, _CurrencySelectors.activeCurrencySelector)(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onUpdateActiveCurrencyCode: function onUpdateActiveCurrencyCode(currency) {
      return dispatch((0, _ActiveCurrencyCodeActions.updateActiveCurrencyCode)({ currency: currency }));
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CurrencyPicker);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/common/CurrencyPicker.js
// module id = 174
// module chunks = 3 4